<template>

    
    
    <div class="col-12 col-xl-4 mm-none" >

                                    <div class="row g-32 settBan">

                                        

                                        <div class="card hp-card-1" >
                                            <div class="card-body py-16">
                                                <div class="row">
                                                    <div class="col-12 mb-8">

                                                        <h3 style="margin-top: 20px; text-align: center; margin-bottom: 20px;">Settings</h3>
                                                        
                                                        <ul class="me-n1 mx-lg-n12">
                                                            <li class="mt-4 mb-16" id="setProfile">
                                                                <router-link :to="{name: 'profile'}" class="active position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center" >
                                                                    <i class="iconly-Curved-User me-16" ></i>
                                                                    <span >Account Information</span>

                                                                    <span id="setProfile2" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-100" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li>

                                                            <li class="mt-4 mb-16" id="setSub">
                                                                <router-link :to="{name: 'sub-bundles'}" class=" position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center">
                                                                    <i class="hp-text-color-dark-0 iconly-Light-Buy me-16"></i>
                                                                    <span>Subscription Bundles</span>

                                                                    <span id="setSub2" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-0" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li>

                                                            <li class="mt-4 mb-16" id="setNoti" >
                                                                <router-link :to="{name: 'noti-settings'}" class="position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center">
                                                                    <i class="iconly-Curved-Notification me-16"></i>
                                                                    <span>Notification Settings</span>

                                                                    <span id="setNoti2" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-0" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li>

                                                            <li id="setActivity" class="mt-4 mb-16">
                                                                <router-link :to="{name: 'activity-monitor'}" class="position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center">
                                                                    <i class="iconly-Curved-Activity me-16"></i>
                                                                    <span>Session Monitor</span>

                                                                    <span id="setActivity2" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-0" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li>

                                                            <li class="mt-4 mb-16" id="setSecurity">
                                                                <router-link :to="{name: 'security-settings'}" class="position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center">
                                                                    <i class="iconly-Curved-Password me-16"></i>
                                                                    <span>Security Settings</span>

                                                                    <span id="setSecurity2" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-0" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li>

                                                            <!-- <li class="mt-4 mb-16" id="setConnect">
                                                                <router-link :to="{name: 'connect-socials'}" class="position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center">
                                                                    <i class="iconly-Light-AddUser me-16"></i>
                                                                    <span>Connect Socials</span>

                                                                    <span id="setConnect2" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-0" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li> -->

                                                            
                                                        </ul>

                                                        <div style="display: flex; justify-content: center; align-items: center; margin-top: 50px;">

                                                            <button @click="back" class="btn btn-danger dd-none">Close</button>

                                                        </div>

                                                    </div>

                                                    
                                                </div>
                                            </div>

                                            
                                        </div>

                                        

                                    </div>

                            </div>


</template>

<style scoped>

    .setActive{

        background-color: #F0F3F5; 
        border-radius: 5px;

    }

    .settBan{
        position: fixed; top: 10px; width: 25%;
    }

    @media only screen and (max-width: 666px){

        .settBan{

            position: static; top: 10px;
            width: 100%;

        }

    }

</style>

<script>

    

    export default {

        
        
        mounted(){

           

            if(this.$route.name == 'profile'){
                document.getElementById('setProfile').classList.add("setActive");
                document.getElementById('setProfile2').classList.add("opacity-100");

            }
            else if(this.$route.name == 'sub-bundles'){

                document.getElementById('setSub').classList.add("setActive");
                document.getElementById('setSub2').classList.add("opacity-100");
            }

            else if(this.$route.name == 'noti-settings'){

                document.getElementById('setNoti').classList.add("setActive");
                document.getElementById('setNoti2').classList.add("opacity-100");
            }

            else if(this.$route.name == 'activity-monitor'){

                document.getElementById('setActivity').classList.add("setActive");
                document.getElementById('setActivity2').classList.add("opacity-100");
            }

            else if(this.$route.name == 'security-settings'){

                document.getElementById('setSecurity').classList.add("setActive");
                document.getElementById('setSecurity2').classList.add("opacity-100");
            }

            else if(this.$route.name == 'connect-socials'){

                document.getElementById('setConnect').classList.add("setActive");
                document.getElementById('setConnect2').classList.add("opacity-100");
            }
        },

        methods:{
            back(){
                this.$router.back();
            }
        }

    }

</script>